<template>
  <div id="app" v-if="!$LoadFromDomain">
    <transition name="van-fade" mode="out-in">
      <router-view
      />
    </transition>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  methods: {
  
  },
  mounted: function () {
   
  },
  updated: function () {
  },
  created() {
  },
};
</script>

<style>
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom)-10px;
  padding-bottom: env(safe-area-inset-bottom)-10px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue